import { render, staticRenderFns } from "./LicenseHolderTag.vue?vue&type=template&id=6b1076d2&lang=pug"
import script from "./LicenseHolderTag.vue?vue&type=script&lang=js"
export * from "./LicenseHolderTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports